import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ChangeRequestStatusType } from 'src/app/enum/change-request-status-type';
import { RoleType } from 'src/app/enum/role-type';
import { ExcelService } from 'src/app/services/excel.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';
import { SearchCriteriaDataService } from 'src/app/services/search-criteria-data-service.service';
import { ServiceChangeRequestService } from 'src/app/services/service-change-request.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ManageServiceChangePopupComponent } from '../manage-service-change-popup/manage-service-change-popup.component';
import { NavigationService } from 'src/app/services/navigation.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-manage-service-change-request',
  templateUrl: './manage-service-change-request.component.html',
  styleUrls: ['./manage-service-change-request.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*', display: 'block', padding: '15px' })),
      transition('expanded <=> collapsed', animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ManageServiceChangeRequestComponent implements OnInit {
  form: FormGroup;
  searchform: FormGroup;
  ChangeRequestStatusType = ChangeRequestStatusType;
  filtershow = false;
  data: any = [];
  dataSource = new MatTableDataSource(this.data);
  roletype = RoleType;

  displayedColumns: string[] = [
    "AU/ADNo",
    "Type",
    "Customer",
    "CustomerNo",
    "ServiceProvider",
    "CurrentService",
    "ChangeOfService",
    "RequestedOn",
    "ServiceChangeDate",
    "EffectiveOn",
    "Status",
    "action"
  ];
  @ViewChild('startDatePicker') startDateDatePicker: MatDatepicker<Date>;
  @ViewChild('endDatePicker') endDateDatePicker: MatDatepicker<Date>;
  @ViewChild('adminStartDatePicker') adminStartDatePicker: MatDatepicker<Date>;
  @ViewChild('adminEndDatePicker') adminEndDatePicker: MatDatepicker<Date>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  dataExcel: any = [];
  excelColumns: string[];
  filterValue: string = "";
  isMenuClick = false;
  productcategory: any;
  filteredList: any;
  applicationstatus: any;
  filteredList1: any;
  sessionDataString: any;
  constructor(
    private sessionService: UserSessionService,
    private formBuilder: FormBuilder,
    private ServiceChangeRequestService: ServiceChangeRequestService,
    private lookupDataService: LookupDataServiceService,
    private loaderService: LoaderService,
    private toastr: NotificationService,
    private excelService: ExcelService,
    private matdialog: MatDialog,
    private NavigationService: NavigationService,
    private SearchCriteriaDataService: SearchCriteriaDataService,
  ) { }

  ngOnInit(): void {
    this.sessionDataString = JSON.parse(
      localStorage.getItem(this.sessionService.localStorageSessionKey)
    );

    this.form = this.formBuilder.group({
      serviceProviderId: [],
      changeRequestStatus: [],
      effectiveStartDate: [],
      effectiveEndDate: [],
      adminApprovedEffectiveStartDate: [],
      adminApprovedEffectiveEndDate: []

    })
    this.searchform = this.formBuilder.group({
      searchQuery: [null, Validators.required],
    })
    let filterdata = this.SearchCriteriaDataService.getValue('search1');
    console.log(filterdata)
    if (filterdata) {
      if (filterdata.searchQuery) {
        this.searchform.controls['searchQuery'].setValue(filterdata.searchQuery);

        this.getTableData(filterdata);
      } else if (filterdata) {

        Object.keys(filterdata).forEach(key => {
          if (this.form.controls[key]) {
            this.form.controls[key].patchValue(filterdata[key]);
          }
        });

        console.log(this.form.value)

        this.isMenuClick = true;
        this.filter();

      }

    }
    else
      this.getTableData("");

    this.getproduct();
    this.getApplicationstatus();
  }


  onDateChange(event: any, controlName: string): void {
    const date = event.value;
    const formattedDate = this.formatDate(date);
    this.form.get(controlName)?.setValue(formattedDate);
  }

  formatDate(date: Date | null): string {
    if (!date) return '';
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }


  getTableData(data) {
    debugger
    if (!data) {
      this.ServiceChangeRequestService.getServiceChangRequestOnLoading(this.isMenuClick).subscribe((result) => {
        console.log("result", result)
        this.data = result;
        debugger
        this.dataExcel = result;
        this.dataSource = new MatTableDataSource(this.data);

        this.dataSource.paginator = this.paginator;
      })
    }
    else {
      this.ServiceChangeRequestService.getServiceChangeRequestSearchView(data, this.isMenuClick).subscribe((res) => {
        console.log(res)
        this.data = res;
        debugger
        this.dataExcel = res;
        this.dataSource = new MatTableDataSource(this.data);

        this.dataSource.paginator = this.paginator;
      })

    }

  }

  getproduct() {
    this.lookupDataService.getServiceProvider().subscribe((result => {
      this.productcategory = result;
      this.filteredList = [...this.productcategory];
    }))

  }
  getApplicationstatus() {
    this.lookupDataService.getApplicationStatusForServiceChange().subscribe((result) => {
      this.applicationstatus = result;
      this.filteredList1 = [...this.applicationstatus];
    })
  }
  clearFilter() {
    this.getTableData(null)
    this.form.reset();
    this.searchform.reset();

    this.SearchCriteriaDataService.removeParticularItem('search1');
  }
  toggleAdvancedFilter() {
    this.filtershow = this.filtershow ? false : true;
    console.log(this.filtershow)

  }
  exportAsXLSX(): void {
    this.loaderService.start();
    setTimeout(() => {
      var exportData = this.dataExcel;
      if (!exportData || exportData.length === 0) {
        this.toastr.showInfo("No data available to export");
        this.loaderService.hide();
        return;
      }
      const excelList = [];
      this.excelColumns = [
        "S.No",
        "Ref.No",
        "Customer",
        "Customer No",
        "Service Provider",
        "Current Service",
        "Change Of Service",
        // "Current Product Code",
        // "Requested Service Change",
        "Requested On",
        "Service Change Date",
        "Effective On",
        "Status",
        "Rejected By"

      ];
      exportData.forEach((a, index) => {
        let customerName = a.customerName;
        let maskedName = this.encryptionname(customerName);
        excelList.push({
          sno: ++index,
          "Ref.No": a.serviceReferencenumber,
          "Customer": maskedName,
          "Customer No": a.customerReferenceNumber,
          "Service Provider": a.serviceProvider,
          "Current Service": a.aliasName,
          "Change Of Service": a.upgrdeProductName,
          // "Current Product": null,
          // "Service Change Product": null,
          "Requested On": a.serviceRequestedOn,
          "Service Change Date": a.requestedCancellationDate,
          "Effective On": a.approveCancellationDate,
          "Status": a.changeRequestStatusName,
          "Rejected By": a.rejectedBy,
        });
      });
      this.excelService.exportAsExcelFile(excelList, "ChangeServiceRequest_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
      this.loaderService.stop();
    }, 500);
  }

  encryptionname(name: string): string {
    const nameParts = name.split(" ");
    let maskedName = nameParts.map(part => {
      if (part.length > 2) {
        return part.substring(0, 2) + 'xxx';
      } else {
        return part;
      }
    }).join(" ");
    return maskedName;
  }
  getStatusClass(status: ChangeRequestStatusType): string {
    switch (status) {
      case this.ChangeRequestStatusType.ServiceDowngradeAPIFaild:
      case this.ChangeRequestStatusType.ServiceUpgradeAPIFaild:
      case this.ChangeRequestStatusType.CancellationAPIFaild:
      case this.ChangeRequestStatusType.ServiceDowngradeCancelled:
      case this.ChangeRequestStatusType.ServiceUpgradeCancelled:
        return 'status-failed';
      case this.ChangeRequestStatusType.ServiceDowngradeCompleted:
      case this.ChangeRequestStatusType.ServiceUpgradeCompleted:
        return 'status-completed';
      case this.ChangeRequestStatusType.ServiceDowngradePending:
      case this.ChangeRequestStatusType.ServiceUpgradePending:
        return 'status-pending';
      case this.ChangeRequestStatusType.ServiceDowngradeRequest:
      case this.ChangeRequestStatusType.ServiceUpgradeRequest:
        return 'status-Request';
      default:
        return '';
    }
  }

  filter() {
    console.log(this.form.value);
    let date = this.form.value;
    if (date.effectiveStartDate && !date.effectiveEndDate) {
      this.form.get('effectiveEndDate')?.setErrors({ 'required': true });
      return;
    }
    if (!date.effectiveStartDate && date.effectiveEndDate) {
      this.form.get('effectiveStartDate')?.setErrors({ 'required': true });
      return;
    }
    if (!date.adminApprovedEffectiveStartDate && date.adminApprovedEffectiveEndDate) {
      this.form.get('adminApprovedEffectiveEndDate')?.setErrors({ 'required': true });
      return;
    }
    if (!date.adminApprovedEffectiveStartDate && date.adminApprovedEffectiveEndDate) {
      this.form.get('adminApprovedEffectiveStartDate')?.setErrors({ 'required': true });
      return;
    }
    else {
      let value = this.getNonNullValues();
      console.log(value)
      this.SearchCriteriaDataService.setValue('search1', value, 'filter');

      this.ServiceChangeRequestService.getAdvancedSearchForServiceChange(value, true).subscribe((result: any) => {
        console.log(result)
        if (result) {
          this.data = result
          this.dataSource = new MatTableDataSource(this.data);
          this.dataExcel = this.data;
          this.dataSource.paginator = this.paginator;
        }
      })
    }
  }

  search() {
    debugger
    let value = this.searchform.value;
    console.log(value)
    if (this.searchform.valid) {
      this.isMenuClick = true
      this.getTableData(value)
      this.SearchCriteriaDataService.setValue('search1', value, 'filter');

    }
  }


  getNonNullValues(): { [key: string]: any } {
    const rawValues = this.form.value;
    const filteredValues = Object.fromEntries(
      Object.entries(rawValues).filter(([key, value]) => value !== null && value !== undefined)
    );
    return filteredValues;
  }

  view(data: any) {
    let val = { applicationId: data.applicationId, serviceChangeRequestId: data.serviceChangeRequestId, title: 'service' }
    this.NavigationService.gotoupgradeapproval(val);
  }

  approve(data, isamend, ismanual = false) {
    var isVumatel;
    var title = "approve";
    var isBalwin;
    if (data.serviceProviderId == 1 && !isamend) {
      title = "vapprove";
      isVumatel = true;
      console.log('v');
    }
    else {
      isVumatel = false;
    }

    if (data.serviceProviderId == 14 && !isamend) {
      title = "bapprove";
      isBalwin = true;
    }
    else {
      isBalwin = false;
    }
    if (ismanual)
      title = "ismanual"

    const dialogref = this.matdialog.open(ManageServiceChangePopupComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog',
      width: "30%",
      data: {
        head: 'Change Of Service',
        title: title,
        data: data,
        ismanual: ismanual,
      }
    });
    dialogref.afterClosed().subscribe((result) => {
      console.log(result)
      if (result.isAgree == 'yes') {
        let value = result.data;
        let postdata: any = {};
        if (result.isAgree == "yes") {
          if (data.changeRequestStatus == ChangeRequestStatusType.ServiceUpgradeRequest || data.changeRequestStatus == ChangeRequestStatusType.ServiceUpgradeAPIFaild)
            data.changeRequestStatus = ChangeRequestStatusType.ServiceUpgradePending;
          else if (data.changeRequestStatus == ChangeRequestStatusType.ServiceDowngradeRequest || data.changeRequestStatus == ChangeRequestStatusType.ServiceDowngradeAPIFaild)
            data.changeRequestStatus = ChangeRequestStatusType.ServiceDowngradePending;

          postdata.id = data.serviceChangeRequestId;
          postdata.vumatelNetworkIdentifier = value.vumatelNetworkIdentifier;
          postdata.balwinComplexType = value.balwinComplexType;
          postdata.balwinComplexUnitNo = value.complexUnitNo;
          postdata.changeRequestStatus = data.changeRequestStatus;
          if (data.requestedCancellationDate != value.effectivedate) {
            value.effectivedate = this.formatDate(value.effectivedate);
          }
          postdata.approveCancellationTs = value.effectivedate;

          postdata.isAmend = isamend;
          if (ismanual) {
            console.log(ismanual)
            postdata.isApprove = false;
          }
          else
            postdata.isApprove = true;

          console.log(postdata);


          this.ServiceChangeRequestService.save(postdata).subscribe((result) => {
            console.log(result);
            if (result) {
              if (result.length == 2) {
                //still note complete
                this.ServiceChangeRequestService.save(postdata).subscribe((result) => {
                  if (result)
                    this.submit(data, result);
                  else
                    this.toastr.showError("Sorry Something went wrong");

                })
              }
              else
                this.submit(data, result);
            }
            else
              this.toastr.showError("Sorry Something went wrong");

          })
          // postdata.approveCancellationTs =


        }

      }
    })
  }

  submit(data, result) {
    if (result.result != undefined) {
      if (result.result.effective_date != null && result.result.orderreference == null) {
        this.toastr.showError(result.result.effective_date);
        this.clearFilter();

      }
      else if (result.success == false) {
        this.toastr.showError(result.errors);
        this.clearFilter();

      }

    }
    else {
      var sendServiceProviderMail: any = {};
      sendServiceProviderMail.applicationId = data.applicationId;
      sendServiceProviderMail.ChangeRequestStatusType = data.changeRequestStatus;
      this.ServiceChangeRequestService.ServiceChangeMailToServiceProvider(sendServiceProviderMail).subscribe((result) => {
        if (result) {
          this.toastr.showSuccess("Service Request Changed Succesfully");
          this.clearFilter();


        }
      })
    }
  }

  reject(data) {
    let title = "reject"
    const dialogref = this.matdialog.open(ManageServiceChangePopupComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog',
      width: "30%",
      data: {
        head: 'Reason for Reject',
        title: title,
        data: data,
      }
    });
    dialogref.afterClosed().subscribe((result) => {
      console.log(result)
      if (result?.data.reason) {
        let value = result.data;
        var postdata: any = {};
        if (data.changeRequestStatus == ChangeRequestStatusType.ServiceUpgradeRequest)
          data.changeRequestStatus = ChangeRequestStatusType.ServiceUpgradeCancelled;
        else if (data.changeRequestStatus == ChangeRequestStatusType.ServiceDowngradeRequest)
          data.changeRequestStatus = ChangeRequestStatusType.ServiceDowngradeCancelled;
        data.reason = value.reason;

        postdata.id = data.serviceChangeRequestId;
        postdata.changeRequestStatus = data.changeRequestStatus;
        postdata.reason = data.reason;
        postdata.applicationId = data.applicationId;
        this.ServiceChangeRequestService.save(postdata).subscribe((result) => {
          console.log(result);
          this.toastr.showSuccess("Service Request Changed Succesfully");
          this.clearFilter();

        });
      }
    });
  }

}
